import type { EspdResponseDto, EspdRequirementResponseDto } from "../../../../../autogen/bff-api";

export const emptyEspd = (): EspdResponseDto => ({
  specVersion: "EHF-ESPD-1.2",
  responses: [],
  economicOperator: { smeIndicator: null, representatives: [] },
  finalDeclaration: { confirmed: false },
});

export const espdAnswerFor = (espd: EspdResponseDto, requirementId: string): EspdRequirementResponseDto | undefined =>
  espd.responses?.find((r) => r.requirementId === requirementId);

export const setEspdAnswer = (
  espd: EspdResponseDto,
  requirementId: string,
  patch: Partial<EspdRequirementResponseDto>,
): EspdResponseDto => {
  const others = (espd.responses ?? []).filter((r) => r.requirementId !== requirementId);
  return { ...espd, responses: [...others, { requirementId, ...patch }] };
};

export const removeEspdAnswer = (
  espd: EspdResponseDto,
  requirementId: string,
): EspdResponseDto => ({
  ...espd,
  responses: (espd.responses ?? []).filter(
    (r) => r.requirementId !== requirementId,
  ),
});

// Display and completeness only: saving the result would persist answers the server owns.
export const withDerivedAnswers = (
  espd: EspdResponseDto,
  derived: EspdRequirementResponseDto[] | undefined
): EspdResponseDto => {
  if (!derived || derived.length === 0) return espd;
  const derivedIds = new Set(derived.map((d) => d.requirementId));
  return {
    ...espd,
    responses: [...(espd.responses ?? []).filter((r) => !derivedIds.has(r.requirementId)), ...derived],
  };
};
